export default "__VITE_ASSET__SvNy3HbY__"